import { isEqual } from "lodash";
import { isPartner } from "../../../helpers/commons.helpers";

/**
 * Sorts an array of customers alphabetically by their first name or company name.
 *
 * @param {Array} customers - The array of customer objects to sort.
 * @returns {Array} - The sorted array of customers.
 */
export function alphabeticallySort(customers = []) {
    return customers.sort(function (a, b) {
        if (a.type === "customer" && b.type === "customer") {
            return a.first_name.localeCompare(b.first_name);
        } else {
            return a.company_name.localeCompare(b.company_name);
        }
    });
}

/**
 * Returns the session/user id used as the reservation's "responsible" owner.
 * @param {Object} sesion - The current user session.
 * @returns {string} - The session user id.
 */
export function getOwner(sesion) {
    return sesion.id;
}

/**
 * Builds the notification config tag/reference depending on whether the customer is a partner
 * (agency/access) or internal.
 * @param {Object} partner - The customer/partner assigned to the reservation.
 * @returns {Object} - The { configTag, configRef } notification tag.
 */
export function getConfigTag(partner) {
    if (isPartner(partner.type)) {
        return { configTag: "rhomtrip_partner", configRef: partner._id };
    }
    return { configTag: "rhomtrip_internal", configRef: null };
}

/**
 * Compares two objects for equality, ignoring the given attribute keys.
 * @param {Object} original - The original object.
 * @param {Object} copy - The object to compare against.
 * @param {Array<string>} attributes - Keys to exclude from the comparison.
 * @returns {boolean} - True if the objects differ (ignoring the excluded keys).
 */
export function hasChanges(original, copy, attributes = []) {
    let originalValue = JSON.parse(JSON.stringify(original));
    let copyValue = JSON.parse(JSON.stringify(copy));
    if (attributes.length) {
        for (let index = 0; index < attributes.length; index++) {
            const attribute = attributes[index];
            delete originalValue[attribute];
            delete copyValue[attribute];
        }
    }
    return !isEqual(originalValue, copyValue);
}